import { makeAutoObservable } from "mobx";
import { UsersContext } from "../../typings/context";
import { ContentMakerProfileInfo } from "../../../api/typings/Profiles";

export class ProfileContenterService {
  constructor(private ctx: UsersContext) {
    this.ctx = ctx;
    makeAutoObservable(this);
  }

  updateProfile = (data: ContentMakerProfileInfo) => {};
}
